import Vue from "vue"
import VueRouter from "vue-router"

import Homepage from "./components/Homepage.vue"
import Notifications from "./components/Notifications.vue"
import FinanceMain from "./components/FinanceMain.vue"
import AdminNotices from "./components/AdminNotices.vue"
import Students from "./components/Students.vue"
import HomeUpdate from "./components/HomeUpdate.vue"
import StudentsDetail from "./components/StudentsDetail.vue"
import SahaDetail from "./components/SahaDetail.vue"
import YeoDetailGider from "./components/YeoDetailGider.vue"
import UpdateGider from "./components/UpdateGider.vue"
import UpdateDelgi from "./components/UpdateDelgi.vue"
import NotesDetail from "./components/NotesDetail.vue"
import NotesDetailSaha from "./components/NotesDetailSaha.vue"
import UploadFile from "./components/UploadFile.vue"
import UpdateMakine from "./components/UpdateMakine.vue"
import UpdatePersonel from "./components/UpdatePersonel.vue"
import MakineFiltre from "./components/MakineFiltre.vue"
import SahaGuncelleme from "./components/SahaGuncelleme.vue"
import PersonelBakiye from "./components/PersonelBakiye.vue"
import YeoMakineler from "./components/YeoMakineler.vue"
import YeoMakineGider from "./components/YeoMakineGider.vue"
import AslanMakineler from "./components/AslanMakineler.vue"
import MakineFiltrele from "./components/MakineFiltrele.vue"
import NakliyeFiltre from "./components/NakliyeFiltre.vue"
import GiderFiltrele from "./components/GiderFiltrele.vue"
import RaporKayit from "./components/RaporKayit.vue"
import RaporGuncelleme from "./components/RaporGuncelleme.vue"
import StokGuncelleme from "./components/StokGuncelleme.vue"
import GiderKayit from "./components/GiderKayit.vue"
import StokKayit from "./components/StokKayit.vue"
import PersonelEkle from "./components/PersonelEkle.vue"
import FileConfirmation from "./components/FileConfirmation.vue"
import NoticesDetail from "./components/NoticesDetail.vue"
import AddNotice from "./components/AddNotice.vue"
import Notes from "./components/Notes.vue"
import NotesSaha from "./components/NotesSaha.vue"
import Cari from "./components/Cari.vue"
import BankChecks from "./components/BankChecks.vue"
import UpdateCheck from "./components/UpdateCheck.vue"
import ChecksCariEntry from "./components/ChecksCariEntry.vue"
import ChecksCariList from "./components/ChecksCariList.vue"
import ChecksMusteriCeki from "./components/ChecksMusteriCeki.vue"
import ChecksCariComplate from "./components/ChecksCariComplate.vue"
import ChecksCustomerEntry from "./components/ChecksCustomerEntry.vue"
import ChecksMain from "./components/ChecksMain.vue"
import YeoSahalar from "./components/YeoSahalar.vue"
import ComplateSaha from "./components/ComplateSaha.vue"
import ComplateSahaTwo from "./components/ComplateSahaTwo.vue"
import YeoComplateSaha from "./components/YeoComplateSaha.vue"
import ComplateFullSaha from "./components/ComplateFullSaha.vue"
import deneme from "./components/deneme.vue"
import denemetwo from "./components/denemetwo.vue"
import Yeodetail from "./components/Yeodetail.vue"
import NotesPage from "./components/NotesPage.vue"
import NotesShow from "./components/NotesShow.vue"
import NotificationsDetail from "./components/NotificationsDetail.vue"
import PersonalSettings from "./components/PersonalSettings.vue"
import AdminPersonalSettings from "./components/AdminPersonalSettings.vue"
import EmailCorrection from "./components/password/EmailCorrection.vue"
import PasswordActivation from "./components/password/PasswordActivation.vue"
import CheckPassword from "./components/password/CheckPassword.vue"
import SignUp from "./components/SignUp.vue"
import Login from "./components/Login.vue"
import NotFound from "./components/NotFound.vue"

import store from "./store"
import PersonelFiltre from "./components/PersonelFiltre.vue"
import Leasing from "./components/Leasing.vue"
import MainPage from "./components/MainPage.vue"


Vue.use(VueRouter)

const routes = [{

        path: "/",
        component: Homepage,
        mode: 'history',
        hash: false,
        home: false,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {

                next("/login")
            }
        }

    },
    {
        path: "/uploadFile",
        name: "uploadFile",
        component: UploadFile,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/updatemakine",
        name: "updatemakine",
        component: UpdateMakine,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/updatepersonel",
        name: "updatepersonel",
        component: UpdatePersonel,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/deneme",
        name: "deneme",
        component: deneme,

    },
    {
        path: "/denemetwo",
        name: "denemetwo",
        component: denemetwo,

    },
    {
        path: "/makinefiltre",
        name: "makinefiltre",
        component: MakineFiltre,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/personelfiltre",
        name: "personelfiltre",
        component: PersonelFiltre,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/nakliyefiltre",
        name: "nakliyefiltre",
        component: NakliyeFiltre,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/sahaguncelleme",
        name: "sahaguncelleme",
        component: SahaGuncelleme,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/personelbakiye",
        name: "personelbakiye",
        component: PersonelBakiye,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/yeomakineler",
        name: "yeomakineler",
        component: YeoMakineler,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/yeomakinegider",
        name: "yeomakinegider",
        component: YeoMakineGider,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/aslanmakineler",
        name: "aslanmakineler",
        component: AslanMakineler,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },

    {
        path: "/raporkayit",
        name: "raporkayit",
        component: RaporKayit,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/raporguncelleme",
        name: "raporguncelleme",
        component: RaporGuncelleme,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/stokguncelleme",
        name: "stokguncelleme",
        component: StokGuncelleme,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/giderkayit",
        name: "giderkayit",
        component: GiderKayit,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/stokkayit",
        name: "stokkayit",
        component: StokKayit,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/personelekle",
        name: "personelekle",
        component: PersonelEkle,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/notifications",
        name: "notifications",
        component: Notifications,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/financemain",
        name: "financemain",
        component: FinanceMain,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/adminNotices",
        name: "adminNotices",
        component: AdminNotices,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/homeUpdate",
        name: "homeUpdate",
        component: HomeUpdate,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/addNotice",
        name: "addNotice",
        component: AddNotice,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/updatedelgi",
        name: "updatedelgi",
        component: UpdateDelgi,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/updategider",
        name: "updategider",
        component: UpdateGider,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/students",
        name: "students",
        component: Students,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/notes",
        name: "notes",
        component: Notes,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/notesSaha",
        name: "notesSaha",
        component: NotesSaha,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/cari",
        name: "cari",
        component: Cari,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/bankchecks",
        name: "bankchecks",
        component: BankChecks,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/checkscarientry",
        name: "checkscarientry",
        component: ChecksCariEntry,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/checksmustericeki",
        name: "checksmustericeki",
        component: ChecksMusteriCeki,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/updateCheck",
        name: "updateCheck",
        component: UpdateCheck,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/carilist",
        name: "carilist",
        component: ChecksCariList,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/checksCariComplate",
        name: "checksCariComplate",
        component: ChecksCariComplate,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/checkscustomerentry",
        name: "checkscustomerentry",
        component: ChecksCustomerEntry,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/checksmain",
        name: "checksmain",
        component: ChecksMain,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/leasing",
        name: "leasing",
        component: Leasing,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/yeoSahalar",
        name: "yeoSahalar",
        component: YeoSahalar,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/complatesaha",
        name: "complatesaha",
        component: ComplateSaha,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/complatesahatwo",
        name: "complatesahatwo",
        component: ComplateSahaTwo,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/yeocomplatesaha",
        name: "yeocomplatesaha",
        component: YeoComplateSaha,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/complatefullsaha",
        name: "complatefullsaha",
        component: ComplateFullSaha,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: '/studentsDetail/:id?',
        name: 'studentsDetail',
        component: StudentsDetail,
    },
    {
        path: '/sahadetail/:id?',
        name: 'sahadetail',
        component: SahaDetail,
    },
    {
        path: '/yeodetailgider/:id?',
        name: 'yeodetailgider',
        component: YeoDetailGider,
    },
    {
        path: '/notesDetail/:id?',
        name: 'NotesDetail',
        component: NotesDetail,
    },
    {
        path: '/notesDetailSaha/:id?',
        name: 'NotesDetailSaha',
        component: NotesDetailSaha,
    },
    {
        path: '/noticesDetail/:id?',
        name: 'noticesDetail',
        component: NoticesDetail,
    },
    {
        path: '/notesPage/:id?',
        name: 'notesPage',
        component: NotesPage,
    },
    {
        path: '/mainpage/:id?',
        name: 'mainpage',
        component: MainPage,
    },
    {
        path: '/makinefiltrele/:id?',
        name: 'makinefiltrele',
        component: MakineFiltrele,
    },
    {
        path: '/giderfiltrele/:id?',
        name: 'giderfiltrele',
        component: GiderFiltrele,
    },
    {
        path: '/yeodetail/:id?',
        name: 'yeodetail',
        component: Yeodetail,
    },
    {
        path: '/notesShow/:id?',
        name: 'notesShow',
        component: NotesShow,
    },
    {
        path: '/notificationsDetail/:id?',
        name: 'notificationsDetail',
        component: NotificationsDetail,
    },
    {
        path: "/personalsettings",
        name: "personalsettings",
        component: PersonalSettings,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/adminpersonalsettings",
        name: "adminpersonalsettings",
        component: AdminPersonalSettings,
        beforeEnter(to, from, next) {


            if (store.getters.isLogin) {
                next()
            } else {
                next("/login")
            }
        }

    },
    {
        path: "/signup",
        name: "signup",
        component: SignUp,
        beforeEnter(to, from, next) {
            next()
        }

    },
    {
        path: "/emailCorrection",
        name: "emailCorrection",
        component: EmailCorrection,
        beforeEnter(to, from, next) {
            next()
        }

    },
    {
        path: "/passwordActivation",
        name: "passwordActivation",
        component: PasswordActivation,
        beforeEnter(to, from, next) {
            next()
        }

    },
    {
        path: "/checkPassword",
        name: "checkPassword",
        component: CheckPassword,
        beforeEnter(to, from, next) {
            next()
        }

    },
    {
        path: "/fileConfirmation",
        name: "FileConfirmation",
        component: FileConfirmation,
        beforeEnter(to, from, next) {
            next()
        }

    },
    {
        path: "/login",
        name: "login",
        component: Login,
        beforeEnter(to, from, next) {

            if (store.getters.isLogin) {
                next("/")
            } else {
                next()
            }
        }

    },
    { path: "/notfound", component: NotFound }


];
export const router = new VueRouter({
    mode: 'hash',
    base: '/',
    routes
});


// WEBPACK FOOTER //
// ./src/router.js